mutation CreateImpactMeasurementCategory(
  $impactMeasurementCategoryInput: ImpactMeasurementCategoryInput!
) {
  createImpactMeasurementCategory(
    input: { impactMeasurementCategoryInput: $impactMeasurementCategoryInput }
  ) {
    impactMeasurementCategory {
      id
    }
  }
}
